import { render, staticRenderFns } from "./departmentMoneyEdit.vue?vue&type=template&id=6360be97&"
import script from "./departmentMoneyEdit.vue?vue&type=script&lang=js&"
export * from "./departmentMoneyEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports